import { PATH_NAME_REVOCATION_DEFENSE } from '@/common/resources/router.const'
export default [
  {
    path: '/promotion/user/:promotionId',
    name: PATH_NAME_REVOCATION_DEFENSE,
    alias: 'promotion/user.html',
    components: {
      revocationPromotion: () =>
        import(
          /* webpackChunkName: "revocation_defense" */ '@/pages/popup/RevocationDefenseMainResultPopup.vue'
        ),
    },
  },
]
